import { ModalContentToggler } from '@components'

import { ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'

import { missingComplianceDetailsModalStates } from '../../constants/missingComplianceDetailsModalStates'
import { MissingComplianceDetailsModalStateId } from '../../enums/missingComplianceDetailsModalStateId'
import { useMissingComplianceDetailsModalStateId } from '../../hooks/useMissingComplianceDetailsModalStateId'

type MissingComplianceDetailsModalComponentProps = ModalProps

export const MissingComplianceDetailsModalComponent = (
  props: MissingComplianceDetailsModalComponentProps,
): ReactElement => {
  const { initialStateId } = useMissingComplianceDetailsModalStateId()

  return (
    <ModalContentToggler<MissingComplianceDetailsModalStateId>
      initialState={initialStateId}
      states={missingComplianceDetailsModalStates}
      {...props}
    />
  )
}
